module.exports = __webpack_public_path__ + "static/img/acq-form-4.8cd8d0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/acq-form-4.png
// module id = 6nqE
// module chunks = 1